var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scale"},[_c('div',{staticClass:"scale__balance",style:(_vm.styleBalance)})])}
var staticRenderFns = []

export { render, staticRenderFns }